import { render, staticRenderFns } from "./PopupTanimla.vue?vue&type=template&id=1a9c8a2c&scoped=true&"
import script from "./PopupTanimla.vue?vue&type=script&lang=js&"
export * from "./PopupTanimla.vue?vue&type=script&lang=js&"
import style0 from "./PopupTanimla.vue?vue&type=style&index=0&id=1a9c8a2c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a9c8a2c",
  null
  
)

export default component.exports